export const portfolio = [
    {
        image: "assets/img/portfolio/1.png",
        href: "assets/img/portfolio/1.png"
    },
    {
        image: "assets/img/portfolio/2.png",
        href: "assets/img/portfolio/2.png"
    },
    {
        image: "assets/img/portfolio/3.png",
        href: "assets/img/portfolio/3.png"
    },
    {
        image: "assets/img/portfolio/4.png",
        href: "assets/img/portfolio/4.png"
    },
    {
        image: "assets/img/portfolio/5.png",
        href: "assets/img/portfolio/5.png"
    },
    {
        image: "assets/img/portfolio/6.png",
        href: "assets/img/portfolio/6.png"
    },
]